import BaseModel from "./BaseModel";
import ScheduleSlotModel from "./ScheduleSlotModel";

export default class ScheduleModel extends BaseModel {
  slotsByDateMap?: { [key: string]: Array<ScheduleSlotModel> };
  slotsByDayMap?: { [key: string]: Array<ScheduleSlotModel> };
  slots?: Array<ScheduleSlotModel>;
  isActive?: boolean;

  constructor(arg: any) {
    super(arg);
    this.slots = ScheduleSlotModel.fromApiResponse(arg.schedule_slots);
    this.isActive = arg.is_active;
  }
}
